import { reportingStandards } from '../index';
import { isTierOTCQB, isTierOTCQX } from '../../utils/helper';

const SUBTITLE = 'Provide contact information below.';

export const providers = [
    {
        title: 'Transfer Agent',
        key: 'transferAgents',
        typeId: '6',
        addTitle: 'Add Transfer Agent',
        moreInfo: 'International companies may list their Registrar',
        isRequired: data => data.edgarFilingStatus && !data.edgarFilingStatus.includes(reportingStandards.INTERNATIONAL)
    },
    {
        title: 'Accountant/Auditor',
        typeId: '5',
        key: 'auditors',
        addTitle: 'Add Accountant/Auditor',
        isRequired: data => data.companyTier && (isTierOTCQB(data.companyTier) || isTierOTCQX(data.companyTier))
    },
    {
        title: 'Securities Counsel',
        typeId: '3',
        addTitle: 'Add Securities Counsel',
        key: 'securityCounsels',
        isRequired: data => data.companyTier && (isTierOTCQB(data.companyTier) || isTierOTCQX(data.companyTier)) && data.edgarFilingStatus && !data.edgarFilingStatus.includes(reportingStandards.INTERNATIONAL)
      },
      {
        title: 'Investor Relations Firm',
        typeId: '2',
        addTitle: 'Add Investor Relations Firm',
        key: 'investorRelations',
      },
      {
        title: 'Investment Bank',
        typeId: '1',
        addTitle: 'Add Investment Bank',
        key: 'investmentBanks',
      }
];
